<template>
    <v-dialog persistent class="dialog" v-model="dialog" origin="top top">
        <v-card class="dialog-rebet__container">
            <template v-if="showTacTacWarning">
                <v-card-title class="text-h8 dialog-rebet__title">
                    <span class="dialog-rebet__title__red">{{ getTranslatedText('reprint dialog tac tac warning headline') }}</span>
                </v-card-title>
                <v-card-text class="dialog-rebet__description">
                    {{ getTranslatedText('reprint dialog tac tac not refundable') }}
                </v-card-text>
                <v-card-actions>
                    <ButtonCommon value="confirm" class-name="dialog__box-button__item uppercase" :isNoHover="true"
                        :isLoading="false" nameFunction="on-reprint-tac-tac-confirm" />
                </v-card-actions>
            </template>
            <template v-else-if="showTicketCancelledConfirm">
                <v-card-title class="text-h8 dialog-rebet__title">
                    <span class="dialog-rebet__title__red">{{ getTranslatedText('reprint dialog ticket cancelled headline') }}</span>
                </v-card-title>
                <v-card-text class="dialog-rebet__description">
                    {{ getTranslatedText('reprint dialog ticket cancelled body') }}
                </v-card-text>
                <v-card-actions>
                    <ButtonCommon value="confirm" class-name="dialog__box-button__item uppercase" :isNoHover="true"
                        :isLoading="false" nameFunction="on-reprint-cancelled-confirm" />
                </v-card-actions>
            </template>
            <template v-else>
                <v-card-title class="text-h8 dialog-rebet__title">
                    <span class="dialog-rebet__title__red dialog-rebet__title__block">{{ getTranslatedText('attention') }}</span>
                    <span v-if="printPhase === 'printing'">{{ getTranslatedText('your transaction has been confirmed') }}</span>
                    <span v-else-if="printPhase === 'cancelling' && awaitingAutoReprintStatus">{{ getTranslatedText('print status headline reprinting') }}</span>
                    <span v-else-if="printPhase === 'cancelling'">{{ getTranslatedText('print status headline fail') }}</span>
                </v-card-title>

                <template v-if="printPhase === 'printing'">
                    <v-card-text class="dialog-rebet__description">{{ getTranslatedText('print status printing body') }}</v-card-text>
                    <v-card-text v-if="printCountdownSeconds > 0" class="dialog-rebet__description dialog-rebet__countdown">{{ getTranslatedText("reprint dialog countdown seconds", { seconds: String(printCountdownSeconds) }) }}</v-card-text>
                </template>

                <template v-else-if="printPhase === 'cancelling' && awaitingAutoReprintStatus">
                    <v-card-text class="dialog-rebet__description">{{ getTranslatedText('reprint dialog reprinting body') }}</v-card-text>
                    <v-card-text v-if="cancellingTimerSeconds > 0" class="dialog-rebet__description dialog-rebet__countdown">{{ getTranslatedText("reprint dialog countdown seconds", { seconds: String(cancellingTimerSeconds) }) }}</v-card-text>
                </template>

                <template v-else-if="printPhase === 'cancelling'">
                    <v-card-text class="dialog-rebet__description">{{ getTranslatedText('reprint dialog cancelling body') }}</v-card-text>
                    <v-card-actions class="dialog-rebet__actions dialog-rebet__actions--right">
                        <button class="button button__default uppercase no-hover dialog-rebet__btn-cancel-timer" disabled>
                            {{ getTranslatedText('reprint dialog cancelling button', { seconds: String(cancellingTimerSeconds) }) }}
                        </button>
                    </v-card-actions>
                </template>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import printMinxin from '@/mixins/print/print-mixin'
import EventBus from "@/utils/EventBus";
import ButtonCommon from "@/components/common/button/index.vue";
import BetslipsService from '@/services/betslip.service'
import { isArrayEmpty } from '@/utils/utils'
import { INSTANT_SLUG_GAME } from '@/constants/lotto'
import { isBypassPrintingUser, resetSimulatePrintCounter } from '@/utils/print-debug'
import Vue from 'vue'

export default {
    mixins: [languageMixins, printMinxin],
    components: { ButtonCommon },
    data() {
        let data =
        {
            dialog: false,
            reference: "",
            ticketType: "",
            isUpdating: false,
            isDevicePrinting: true,
            printStatusMessage: '',
            paramPrint: null,
            userInfo: null,
            reprintCount: 0,
            reprintCountToShowCancel: this.$store.state.reprintCountToShowCancel ?? 3,
            showCancelationInPos: this.$store.state.showCancelationInPos ?? false,
            milisecondsToForceFinishPrinting: this.$store.state.milisecondsToForceFinishPrinting ?? 4000,
            autoCancelUnprintedCountdownSeconds: this.$store.state.autoCancelUnprintedCountdownSeconds ?? 60,
            maxReprintAttempts: this.$store.state.maxAutoReprintAttempts ?? 1,
            forSport: false,
            forLotto: false,
            showTicketCancelledConfirm: false,
            showTacTacWarning: false,
            printPhase: 'idle',
            printCountdownSeconds: 0,
            printCountdownIntervalId: null,
            cancellingTimerSeconds: 0,
            cancellingTimerIntervalId: null,
            awaitingAutoReprintStatus: false,
            printerStatusRequested: false,
            printerPollIntervalId: null,
            awaitingReprintTimeoutId: null,
            stopRetryWhenSecondsLeft: 5,
            printerPollMs: 2000,
            cancelledConfirmTimeoutId: null,
            cancelledConfirmAutoCloseMs: 2000,
        };
        return data;
    },
    mounted() {
        document.addEventListener('message', this.handlePrintMessageFromApk)
    },
    created() {
        EventBus.$on("on-show-reprint", (param) => {
            resetSimulatePrintCounter()
            this.showTicketCancelledConfirm = false
            this.showTacTacWarning = false
            this.isDevicePrinting = true
            this.reprintCount = 0
            this.awaitingAutoReprintStatus = false
            this.printerStatusRequested = false
            Vue.prototype.$isReprintDialogShowing = true
            Vue.prototype.$currentPrintContext = {
                reference: param.reference,
                ticketType: param.ticketType,
                ticketId: param.betslipId,
                reprintCount: 0,
            }
            this.reference = param.reference;
            this.betslipId = param.betslipId;
            this.ticketType = param.ticketType;
            this.paramPrint = param.paramPrint;
            this.userInfo = param.userInfo;
            this.dialog = true;
            this.forSport = param.forSport;
            this.forLotto = param.forLotto;

            this.initTimeoutToForceFinishPrinting()
            this.startPrintPhase()

            this.$nextTick(() => {
                if (this.forSport === true) {
                    this.printSports(this.paramPrint)
                }
                if (this.forLotto === true) {
                    this.printLoto(this.paramPrint)
                }
            })
        });

        // actions
        EventBus.$on("on-print-ok", () => this.updatePrintingStatus());
        EventBus.$on("on-print-cancel", () => this.cancelBetslip());
        EventBus.$on("on-print-close", () => this.closeOnFailedPrinting());
        EventBus.$on("on-print-reprint", () => this.reprint());
        EventBus.$on("on-print-close", () => this.closeDialog());
        EventBus.$on("on-reprint-cancelled-confirm", () => this.goHomeAfterTicketCancelled());
        EventBus.$on("on-reprint-tac-tac-confirm", () => this.goHomeAfterTacTacWarning());
    },
    beforeDestroy() {
        this.clearPrintCountdown()
        this.clearCancellingCountdown()
        this.clearPrinterPolling()
        this.clearAwaitingReprintTimeout()
        this.clearCancelledConfirmAutoClose()
        document.removeEventListener('message', this.handlePrintMessageFromApk)
    },
    destroyed() {
        EventBus.$off("on-show-reprint");

        EventBus.$off("on-print-ok");
        EventBus.$off("on-print-cancel");
        EventBus.$off("on-print-close");
        EventBus.$off("on-print-reprint");
        EventBus.$off("on-print-close");
        EventBus.$off("on-reprint-cancelled-confirm");
        EventBus.$off("on-reprint-tac-tac-confirm");
    },
    watch: {
        dialog(newVal) {
            if (!newVal) {
                this.clearPrintCountdown()
                this.clearCancellingCountdown()
                this.clearPrinterPolling()
                this.clearAwaitingReprintTimeout()
                this.clearCancelledConfirmAutoClose()
            }
        },
    },
    computed: {
        isTacTac() {
            try {
                return this.paramPrint?.transaction?.additionalInformation?.game_slug === INSTANT_SLUG_GAME
            } catch {
                return false
            }
        },
    },
    methods: {
        goHomeAfterTicketCancelled() {
            this.clearCancelledConfirmAutoClose()
            this.showTicketCancelledConfirm = false
            this.dialog = false
            Vue.prototype.$isReprintDialogShowing = false
            Vue.prototype.$currentPrintContext = null
            this.$router.push('/')
        },

        startCancelledConfirmAutoClose() {
            // Cancelled-confirm screen is showing — if the cashier does nothing,
            // close it (go home) automatically after a short delay.
            this.clearCancelledConfirmAutoClose()
            this.cancelledConfirmTimeoutId = setTimeout(() => {
                this.cancelledConfirmTimeoutId = null
                if (this.showTicketCancelledConfirm) {
                    this.goHomeAfterTicketCancelled()
                }
            }, this.cancelledConfirmAutoCloseMs)
        },

        clearCancelledConfirmAutoClose() {
            if (this.cancelledConfirmTimeoutId != null) {
                clearTimeout(this.cancelledConfirmTimeoutId)
                this.cancelledConfirmTimeoutId = null
            }
        },

        goHomeAfterTacTacWarning() {
            this.showTacTacWarning = false
            this.dialog = false
            Vue.prototype.$isReprintDialogShowing = false
            Vue.prototype.$currentPrintContext = null
            this.$router.push('/')
        },

        closeDialog() {
             try {
                BetslipsService.cancelBetslip(this.betslipId, true)
             } catch (error) {
             }
            this.dialog = false
            Vue.prototype.$isReprintDialogShowing = false
            Vue.prototype.$currentPrintContext = null
            this.clearPrintCountdown()
            this.clearCancellingCountdown()
        },

        handlePrintMessageFromApk(event) {
            const resp = JSON.parse(event.data)

            if (resp.command === 'print-status') {
                // code 100 = "started" — beginJob succeeded, the real 200/400 is still coming.
                if (resp.code === 100) {
                    // "started" heartbeat — the real 200/400 is still coming. The
                    // cancelling timer is reset when we fire the reprint (autoReprint),
                    // not here, so this is a no-op.
                    return
                }

                if (resp.code === 200) {
                    this.printStatusMessage = 'ok'
                } else {
                    this.printStatusMessage = 'not ok'
                }
                this.isDevicePrinting = false

                // ignore "Printer is busying" — the previous print is still running,
                // its own print-status will arrive next.
                const isBusyReject = resp.code === 400 && !resp.errorCode &&
                    typeof resp.message === 'string' && resp.message.toLowerCase().includes('busy')
                if (isBusyReject) return

                // Auto-reprint response: a retry we fired during the cancelling phase.
                if (this.awaitingAutoReprintStatus) {
                    this.awaitingAutoReprintStatus = false
                    this.clearAwaitingReprintTimeout()
                    if (resp.code === 200) {
                        this.closeOnSuccessfulPrinting()
                        return
                    }
                    // Failed retry. If reprint attempts remain, keep polling for the
                    // printer to recover; otherwise stop checking and let the cancelling
                    // timer run down to auto-cancel.
                    if (this.canReprint() && this.cancellingTimerSeconds > this.stopRetryWhenSecondsLeft) {
                        if (this.printerPollIntervalId == null) this.startPrinterPolling()
                    } else {
                        this.clearPrinterPolling()
                    }
                    return
                }

                // Initial print response
                if (this.printPhase === 'printing') {
                    this.clearPrintCountdown()
                    if (resp.code === 200) {
                        this.closeOnSuccessfulPrinting()
                    } else {
                        this.enterCancellingPhase()
                    }
                    return
                }

                // A print-status during cancelling that is NOT one of our retries:
                // the original (slow) job finished after the print countdown already
                // flipped us into cancelling. A 200 means it actually printed; a 400
                // means it failed in the background.
                if (this.printPhase === 'cancelling') {
                    if (resp.code === 200) {
                        this.closeOnSuccessfulPrinting()
                    } else if (this.canReprint() && this.printerPollIntervalId == null &&
                        this.cancellingTimerSeconds > this.stopRetryWhenSecondsLeft) {
                        // make sure we are polling so we can reprint once the cashier
                        // fixes the hardware
                        this.startPrinterPolling()
                    }
                    return
                }
                return
            }

            if (resp.command === 'printer-status') {
                if (this.printPhase !== 'cancelling') return
                if (this.awaitingAutoReprintStatus) return
                // Too little time left to safely start another print — stop trying.
                if (this.cancellingTimerSeconds <= this.stopRetryWhenSecondsLeft) {
                    this.clearPrinterPolling()
                    return
                }
                // resp.code is IPC success; real printer state is resp.status.code === 1
                const ipcOk = resp.code === 200
                const stateOk = resp.status && resp.status.code === 1
                const notBusy = !resp.isPrinting
                if (!(ipcOk && stateOk && notBusy)) return

                // Printer is ready again. Reprint only while attempts remain; on this
                // APK build every fault flushes the firmware buffer, so nothing
                // auto-resumes — the receipt only comes from a fresh reprint job.
                if (!this.canReprint()) {
                    this.clearPrinterPolling()
                    return
                }
                this.autoReprint()
            }
        },

        startPrintPhase() {
            this.printPhase = 'printing'
            this.clearPrinterPolling()
            this.clearAwaitingReprintTimeout()
            this.startPrintCountdown()
        },

        clearPrintCountdown() {
            if (this.printCountdownIntervalId != null) {
                clearInterval(this.printCountdownIntervalId)
                this.printCountdownIntervalId = null
            }
        },

        startPrintCountdown() {
            this.clearPrintCountdown()
            const ms = this.milisecondsToForceFinishPrinting > 0 ? this.milisecondsToForceFinishPrinting : 4000
            this.printCountdownSeconds = Math.ceil(ms / 1000)
            this.printCountdownIntervalId = setInterval(() => {
                const next = this.printCountdownSeconds - 1
                if (next <= 0) {
                    this.printCountdownSeconds = 0
                    this.clearPrintCountdown()
                    if (this.printPhase === 'printing') {
                        this.enterCancellingPhase()
                    }
                    return
                }
                this.printCountdownSeconds = next
            }, 1000)
        },

        enterCancellingPhase() {
            this.printPhase = 'cancelling'
            this.printerStatusRequested = false
            this.awaitingAutoReprintStatus = false
            this.startCancellingCountdown()
            if (isBypassPrintingUser()) {
                // bypass-list user — treat printer as always ready,
                // skip get-printer-status and auto-reprint immediately
                this.autoReprint()
                return
            }
            // The printer reported a fault (out of paper, cover open, cutter jam,
            // overheating, timeout, …). On this APK build the firmware buffer is
            // flushed on every fault, so nothing auto-resumes — the cashier fixes the
            // hardware and we reprint. Poll until the printer is ready again, then
            // auto-reprint.
            this.startPrinterPolling()
        },

        requestPrinterStatus() {
            if (this.printerStatusRequested) return
            this.printerStatusRequested = true
            try {
                parent.postMessage({ command: 'get-printer-status' }, '*')
            } catch (e) {
                // ignore — cancelling timer will run to 0 if no response
            }
        },

        sendPrinterStatusProbe() {
            try {
                parent.postMessage({ command: 'get-printer-status' }, '*')
            } catch (e) {
                // ignore — cancelling timer will run to 0 if no response
            }
        },

        startPrinterPolling() {
            this.clearPrinterPolling()
            // Probe immediately, then on an interval until the printer recovers or the
            // cancelling timer nears its end.
            this.sendPrinterStatusProbe()
            this.printerPollIntervalId = setInterval(() => {
                if (this.printPhase !== 'cancelling') {
                    this.clearPrinterPolling()
                    return
                }
                if (this.cancellingTimerSeconds <= this.stopRetryWhenSecondsLeft) {
                    this.clearPrinterPolling()
                    return
                }
                // A retry is in flight — wait for its print-status before probing again.
                if (this.awaitingAutoReprintStatus) return
                this.sendPrinterStatusProbe()
            }, this.printerPollMs)
        },

        clearPrinterPolling() {
            if (this.printerPollIntervalId != null) {
                clearInterval(this.printerPollIntervalId)
                this.printerPollIntervalId = null
            }
        },

        clearAwaitingReprintTimeout() {
            if (this.awaitingReprintTimeoutId != null) {
                clearTimeout(this.awaitingReprintTimeoutId)
                this.awaitingReprintTimeoutId = null
            }
        },

        canReprint() {
            return this.reprintCount < this.maxReprintAttempts
        },

        clearCancellingCountdown() {
            if (this.cancellingTimerIntervalId != null) {
                clearInterval(this.cancellingTimerIntervalId)
                this.cancellingTimerIntervalId = null
            }
        },

        startCancellingCountdown() {
            this.clearCancellingCountdown()
            const seconds = this.autoCancelUnprintedCountdownSeconds > 0 ? this.autoCancelUnprintedCountdownSeconds : 60
            this.cancellingTimerSeconds = seconds
            this.cancellingTimerIntervalId = setInterval(() => {
                const next = this.cancellingTimerSeconds - 1
                if (next <= 0) {
                    this.cancellingTimerSeconds = 0
                    this.clearCancellingCountdown()
                    if (this.printPhase === 'cancelling') {
                        this.handleCancellingTimeout()
                    }
                    return
                }
                this.cancellingTimerSeconds = next
                if (next <= this.stopRetryWhenSecondsLeft) {
                    // Not enough time to safely begin another print.
                    this.clearPrinterPolling()
                }
            }, 1000)
        },

        handleCancellingTimeout() {
            this.clearPrinterPolling()
            this.clearAwaitingReprintTimeout()
            this.awaitingAutoReprintStatus = false
            try {
                BetslipsService.cancelBetslip(this.betslipId, true)
            } catch (error) {
                // silent — show cancelled confirm regardless
            }
            this.showTicketCancelledConfirm = true
            this.startCancelledConfirmAutoClose()
        },

        autoReprint() {
            if (this.printPhase !== 'cancelling') return
            if (!this.canReprint()) return
            this.awaitingAutoReprintStatus = true
            this.reprintCount++
            if (Vue.prototype.$currentPrintContext) {
                Vue.prototype.$currentPrintContext.reprintCount = this.reprintCount
            }
            // Reprint job is starting — give the cashier the full window again so the
            // reprint has time to complete before auto-cancel.
            this.startCancellingCountdown()
            // Safety net: if no print-status comes back, stop waiting so polling can
            // probe again (the cancelling timer still guards the hard deadline).
            this.clearAwaitingReprintTimeout()
            const waitMs = this.milisecondsToForceFinishPrinting > 0
                ? this.milisecondsToForceFinishPrinting + 2000
                : 6000
            this.awaitingReprintTimeoutId = setTimeout(() => {
                this.awaitingAutoReprintStatus = false
                this.awaitingReprintTimeoutId = null
            }, waitMs)
            this.$nextTick(() => {
                if (this.forSport === true) {
                    this.printSports(this.paramPrint, true)
                }
                if (this.forLotto === true) {
                    this.printLoto(this.paramPrint, true)
                }
            })
        },

        closeOnSuccessfulPrinting() {
            this.clearPrintCountdown()
            this.clearCancellingCountdown()
            this.clearPrinterPolling()
            this.clearAwaitingReprintTimeout()
            this.awaitingAutoReprintStatus = false
            this.printerStatusRequested = false
            this.reprintCount = 0
            this.isDevicePrinting = false
            this.dialog = false
            Vue.prototype.$isReprintDialogShowing = false
            Vue.prototype.$currentPrintContext = null
        },

        updatePrintingStatus() {
            this.dialog = false;

            this.reprintCount = 0
            this.isDevicePrinting = false

            Vue.prototype.$isReprintDialogShowing = false
            Vue.prototype.$currentPrintContext = null
        },

        closeOnFailedPrinting() {
            this.dialog = false;

            this.reprintCount = 0
            this.isDevicePrinting = false

            Vue.prototype.$isReprintDialogShowing = false
            Vue.prototype.$currentPrintContext = null
        },

        async cancelBetslip() {
            if (this.isUpdating === true) return;
            this.isUpdating = true;

            try {
                const resp = await BetslipsService.cancelBetslip(this.betslipId, true)
                if (this.isTacTac) return;
                if (resp.status === 200) {
                    let message = ''
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                            message += element.message
                        })
                        : (message = resp.message)
                    const param = {
                        text: message ? message : 'cancel successfully',
                        type: 'success',
                    }
                    EventBus.$emit('show-notications', param)

                    this.showTicketCancelledConfirm = true
                    this.startCancelledConfirmAutoClose()
                } else {
                    let message = ''
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                            message += element.message
                        })
                        : (message = resp.message)
                    const param = {
                        text: message,
                        type: 'error',
                        className: 'up-first'
                    }
                    EventBus.$emit('show-notications', param)
                }
            } catch (error) {
                console.log(error)
                const param = {
                    text: 'System error',
                    type: 'error',
                    className: 'up-first'
                }
                EventBus.$emit('show-notications', param)
            }

            this.isUpdating = false;
        },

        async reprint() {
            this.reprintCount++;
            if (Vue.prototype.$currentPrintContext) {
                Vue.prototype.$currentPrintContext.reprintCount = this.reprintCount
            }
            this.isDevicePrinting = true
            this.initTimeoutToForceFinishPrinting()
            this.startPrintPhase()

            if (this.forSport === true) {
                this.printSports(this.paramPrint, true)
            }

            if (this.forLotto === true) {
                this.printLoto(this.paramPrint, true)
            }
        },

        initTimeoutToForceFinishPrinting() {
            setTimeout(() => {
                this.isDevicePrinting = false
            }, this.milisecondsToForceFinishPrinting);
        }
    },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/common/_dialog-rebet.scss";

.dialog-rebet__countdown {
    font-weight: 600;
    margin-top: 8px;
}

.dialog-rebet__title__block {
    display: block;
    width: 100%;
}

.dialog-rebet__actions {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    width: 100%;
    gap: 12px;
}

.dialog-rebet__actions--right {
    justify-content: flex-end !important;
}

.dialog-rebet__actions-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.dialog-rebet__btn-danger {
    color: #d32f2f !important;
}

.dialog-rebet__btn-safe {
    color: #1e6e3a !important;
}

.dialog-rebet__btn-cancel-timer {
    background-color: #d32f2f !important;
    color: #ffffff !important;
    border: none !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
    pointer-events: none;
}

.dialog-rebet__btn-cancel-timer:disabled {
    background-color: #d32f2f !important;
    color: #ffffff !important;
    opacity: 1 !important;
}
</style>
